module.exports = __webpack_public_path__ + "img/text.b5b0a052.svg";